import { render, staticRenderFns } from "./navbar1.vue?vue&type=template&id=07f29e36"
import script from "./navbar1.vue?vue&type=script&lang=ts"
export * from "./navbar1.vue?vue&type=script&lang=ts"
import style0 from "./navbar1.vue?vue&type=style&index=0&id=07f29e36&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f29e36')) {
      api.createRecord('07f29e36', component.options)
    } else {
      api.reload('07f29e36', component.options)
    }
    module.hot.accept("./navbar1.vue?vue&type=template&id=07f29e36", function () {
      api.rerender('07f29e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/navbar1.vue"
export default component.exports